import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FcuIDs } from '@helpers/ams-data-fram-constants';
import { SystemPageType } from '@pages/ops-system-status/ops-system-status.component';
import { SystemStatusRoutingService } from '@service/system-status-routing.service';

@Component({
    selector: 'app-overview-system-error-indicator',
    templateUrl: './overview-system-error-indicator.component.html',
    styleUrls: ['./overview-system-error-indicator.component.scss'],
    standalone: false
})
export class OverviewSystemErrorIndicatorComponent {
    @Input() systemErrors: [string, { [key: string]: 0 }][];
    @Output() onPageSelected: EventEmitter<string> = new EventEmitter<string>();

    eapTranslationString: string = 'system-status.eap';
    opsTranslationString: string = 'system-status.ops';
    fcuTranslationString: string = 'system-status.fcu';
    fuTranslationString: string = 'system-status.fu';
    slotTranslationString: string = 'system-status.fu.slot';
    commIFTranslationString: string = 'system-status.comms';
    commIFPortTranslationString: string = 'system-status.comms.port';
    printerTranslationString: string = 'system-status.printers';

    constructor(private systemStatusRoutingService: SystemStatusRoutingService) {}

    isFcuError(errorLocation: string): boolean {
        const objectKeyArray = errorLocation.split('.');
        return (
            objectKeyArray[objectKeyArray.length - 1] === 'fcuA' ||
            objectKeyArray[objectKeyArray.length - 1] === 'fcuB'
        );
    }

    getErrorLocation(errorLocation: string) {
        const objectKeyArray = errorLocation.split('.');
        return objectKeyArray[objectKeyArray.length - 2];
    }

    getIndex(errorString: string) {
        const objectKeyArray = errorString.split('.');
        return Number(objectKeyArray[objectKeyArray.length - 1]) + 1;
    }

    getFcuLetter(errorString: string) {
        const objectKeyArray = errorString.split('');
        return objectKeyArray[errorString.length - 1];
    }

    getErrorType(errorObject) {
        return Object.keys(errorObject)[0];
    }

    errorlocation(errorLocation: string) {
        const objectKeyArray = errorLocation.split('.');
        if (objectKeyArray.length <= 2) {
            return [{ location: objectKeyArray[0], index: '' }];
        }
        const locations = [];
        for (let i = 0; i < objectKeyArray.length - 2; i = i + 2) {
            let index = Number(objectKeyArray[i + 1]) + 1;
            if (objectKeyArray[i] === 'fcu') {
                index = FcuIDs[Number(objectKeyArray[i + 1])];
            }
            locations.push({
                location: objectKeyArray[i],
                index: index,
            });
        }
        return locations;
    }

    openSelectedPage(page) {
        this.onPageSelected.emit(page);
    }

    handlePageSelected(page) {
        this.openSelectedPage(page);
    }

    handleFuSelected(errorString) {
        this.openSelectedPage(SystemPageType.Fcu);
        const objectKeyArray = errorString.split('.');
        const fuIndex = Number(objectKeyArray[3]);
        const fcuSrc = objectKeyArray[1];
        this.systemStatusRoutingService.openSelectedFu({ fcuSrc, fuIndex });
    }

    handleFcuSelected(errorString) {
        this.openSelectedPage(SystemPageType.Fcu);
        const objectKeyArray = errorString.split('.');
        this.systemStatusRoutingService.openSelectedFcu(objectKeyArray[1]);
    }

    handleCommIFSelected(errorString) {
        this.openSelectedPage(SystemPageType.Comms);
        const objectKeyArray = errorString.split('.');
        this.systemStatusRoutingService.openSelectedCommIF(objectKeyArray[1]);
    }
}
